// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__xd7Eh","footer":"ModalCreateQualiphyProcedure_footer__2JH_o","additionData":"ModalCreateQualiphyProcedure_additionData__2pdi-"};